<template>
  <div
    class="drop-pos"
    :style="{ width }"
  >
    <van-image
      width="100%"
      fit="cover"
      :src="cpSrc"
      :show-loading="false"
    />
    <div
      v-for="(item, key) in pointInfo"
      :key="key"
      :style="{left: `${item.x}%`, top: `${item.y}%`}"
      :class="[view == key ? 'pt-h' : '','pt pt1 fade-ani']"
      @click="$emit('viewChange', key)"
    >
      <van-image
        v-if="view == key"
        width="38px"
        fit="cover"
        class="point fade-ani"
        :style="{ transform: `rotate(${item.rotate + offRotate}deg)`}"
        :src="require('@/imgs/point.png')"
        :show-loading="false"
      />
    </div>

    <van-image
      width="16%"
      fit="cover"
      class="abs-b-r fade-ani"
      style="right: -18%;"
      :src="isOpen ? require('@/imgs/close_01.png') : require('@/imgs/open.png')"
      :show-loading="false"
      @click="toggleOpen"
    />
  </div>
</template>
<script>
export default {
  props: {
    cpSrc: {
      type: String,
      default: '',
    },
    view: {
      type: String,
      default: '01',
    },
    offRotate: {
      type: Number,
      default: 1,
    },
    pointInfo: {
      type: Object,
      default: () => {},
    }, // 点位信息
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    width() {
      return this.isOpen ? '8rem' : '4rem';
    },
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
    onTap(e) {
      // 暂时不需要区域 仅点击点位切换即可
      const { posInfo, width, height } = this;
      const offx = e.offsetX / width;
      const offy = e.offsetY / height;
      console.log(offx, offy);
      const view = Object.keys(posInfo).find(
        (key) => posInfo[key].minx <= offx
          && posInfo[key].maxx >= offx
          && posInfo[key].miny < offy
          && posInfo[key].maxy > offy,
      );
      if (view) {
        this.$emit('viewChange', parseInt(view, 10));
      }
    },
  },
};
</script>

<style lang="less" scoped>
.pt {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #d8b588;
  // background-color: #fac5be;
  border-radius: 600px;
  &:after {
    content: '';
    display: block;
    position: relative;
    z-index: 10;
    left: 2px;
    top: 2px;
    width: 6px;
    height: 6px;
    // background-color: #707070;
    background-color: #f1f1f1;
    border-radius: 600px;
  }
  .point {
    position: absolute;
    top: -32px;
    left: -14px;
    transform-origin: 50% 100%;
    transition: all .2s ease-in-out;
  }
}
.pt-h {
  background-color: #fac5be;
  &:after {
    background-color: #f56c6c;
  }
}
.drop-pos {
  display: flex;
  transition: all .5s linear;
}
.test {
  position: absolute;
  width: 5px;
  height: 5px;
  background-color: blue;
}
.test1 {
  left: 15%;
  top: 29%;
}
.test3 {
  left: 37%;
  top: 37%;
}
</style>
